<div class="app-component app-container ver2">
    <router-outlet></router-outlet>
</div>
